import React from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import RequireAnyCan from "../../authz/RequireAnyCan";
import RequireCan from "../../authz/RequireCan";
import MyDirectoryProfile from "../../pages/MyDirectoryProfile";
import MyClassrooms from "./MyClassrooms";
import MyEnvironment from "./MyEnvironment";
import MyOutings from "./Outings";
import ParentMeetingPlanner from "./ParentMeetingPlanner";
import MyParentMeetings from "./ParentMeetings";
import TeacherAttendanceToday from "./TeacherAttendanceToday";
import TeacherDetails from "./TeacherDetails";

const LegacyParentMeetingPlannerRedirect = () => {
  const { classroomId } = useParams();
  return <Navigate to={`/parent-meetings/${classroomId}/new`} replace />;
};

export const createTeacherPortalRoutes = ({
  myEnvironmentRouteChecks,
  myClassroomsRouteChecks,
  myParentMeetingsRouteChecks,
  myOutingsRouteChecks,
  classroomManagementRouteChecks,
  schoolRootRouteChecks,
}) => (
  <>
    <Route
      path="/my"
      element={
        <RequireAnyCan checks={myEnvironmentRouteChecks} fallback={<Navigate to="/403" />}>
          <MyEnvironment />
        </RequireAnyCan>
      }
    />
    <Route
      path="/my/details"
      element={
        <RequireCan resource="my.teacher-details" action="view" fallback={<Navigate to="/403" />}>
          <TeacherDetails />
        </RequireCan>
      }
    />
    <Route
      path="/my/classrooms"
      element={
        <RequireAnyCan checks={myClassroomsRouteChecks} fallback={<Navigate to="/403" />}>
          <MyClassrooms />
        </RequireAnyCan>
      }
    />
    <Route
      path="/my/parent-meetings"
      element={
        <RequireAnyCan checks={myParentMeetingsRouteChecks} fallback={<Navigate to="/403" />}>
          <MyParentMeetings />
        </RequireAnyCan>
      }
    />
    <Route
      path="/my/outings"
      element={
        <RequireAnyCan checks={myOutingsRouteChecks} fallback={<Navigate to="/403" />}>
          <MyOutings />
        </RequireAnyCan>
      }
    />
    <Route
      path="/my/directory-profile"
      element={
        <RequireCan resource="directory" action="edit" fallback={<Navigate to="/403" />}>
          <MyDirectoryProfile />
        </RequireCan>
      }
    />
    <Route
      path="/attendance"
      element={
        <RequireCan resource="school.attendance" action="view" fallback={<Navigate to="/403" />}>
          <RequireAnyCan
            checks={[
              { resource: "school.attendance", action: "list" },
              { resource: "school.attendance", action: "read" },
              { resource: "school.attendance", action: "view" },
            ]}
          >
            <RequireCan resource="school.attendance" action="manage" fallback={<Navigate to="/403" />}>
              <TeacherAttendanceToday />
            </RequireCan>
          </RequireAnyCan>
        </RequireCan>
      }
    />
    <Route
      path="/parent-meetings/:classroomId/new"
      element={
        <RequireAnyCan checks={classroomManagementRouteChecks}>
          <ParentMeetingPlanner />
        </RequireAnyCan>
      }
    />
    <Route
      path="/school/classrooms/:classroomId/parent-meetings/new"
      element={
        <RequireAnyCan checks={schoolRootRouteChecks}>
          <LegacyParentMeetingPlannerRedirect />
        </RequireAnyCan>
      }
    />
  </>
);
